// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Canvas_wrapper__1JWVQ","blendMode":"Canvas_blendMode__3f911","image":"Canvas_image__jsIJ1"};